import { render, staticRenderFns } from "./ObservatoryUsageGuide.vue?vue&type=template&id=dbb82fc8&scoped=true&"
import script from "./ObservatoryUsageGuide.vue?vue&type=script&lang=js&"
export * from "./ObservatoryUsageGuide.vue?vue&type=script&lang=js&"
import style0 from "./ObservatoryUsageGuide.vue?vue&type=style&index=0&id=dbb82fc8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb82fc8",
  null
  
)

export default component.exports